/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Welcome1/view.blocks to change it.
import * as fromHelpers from './helpers.js'
import ButtonIconSquare from 'DesignSystem/ButtonIconSquare/index'
import CaptchaInfo from 'DesignSystem/CaptchaInfo/index'
import React from 'react'
import Welcome from 'DesignSystem/Svgs/Welcome/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
import viewPath from './viewPath.js'
import { animated, useSpring } from "@react-spring/web"



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Welcome1({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/Welcome"
  
}) {
  let isBefore = useIsBefore()
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let animatedVertical10 = useSpring({
"config": {
tension: 180,
friction: 12,
},
"delay": 250,
"from": {"scale": 1},
"to": {"scale": isBefore ? 0.75 : 1},
})
  return (<React.Fragment
>
<div
  data-testid="Welcome.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<animated.div
  data-testid="Welcome.Vertical:1"
  data-view-path={viewPath}
 style={{"--s-1-Z1DTDk4": animatedVertical10.scale,}}
 className={`views-block ${styles.Vertical1}`}
>
<ButtonIconSquare
  viewPath={`${viewPath}/ButtonIconSquare`}
 onClick={onClick}
 marginTopText={40}
 text="Schedule New Patient Appointment"
 width={340}
 height={340}
>
{childProps => (
<Welcome
{...childProps}
  viewPath={`${viewPath}/Welcome`}
 height={200}
 width={360}
/>
)}
</ButtonIconSquare>
<CaptchaInfo
  viewPath={`${viewPath}/CaptchaInfo`}
/>
</animated.div>
</div>
{children}
</React.Fragment>)
}